import React, { useEffect, useState } from "react";
import CustomSelect from "./CustomSelect";
import { useTranslation } from "react-i18next";
import { GetProgramReportTypes } from "../../api/program-reports/getProgramReportTypes";

const ProgramReportTypeSelect = (props) => {
  const { t } = useTranslation();

  const [availableOptions, setAvailableOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setAvailableOptions([]);
    if (props.program) {
      const setReportTypes = async function () {
        try {
          setLoading(true);
          const data = await GetProgramReportTypes(props.program);
          let availableReports = [];
          Object.entries(data).forEach(([key, value]) => {
            const reportName = key;
            if (value === true && reportName) {
              availableReports.push({
                value: reportName,
                label:
                  reportName.charAt(0).toUpperCase() +
                  reportName.slice(1).replaceAll("_", " "),
              });
            }
          });
          setAvailableOptions(availableReports);
        } catch (err) {
          console.log("Error fetching report types: " + err);
        } finally {
          setLoading(false);
        }
      };
      setReportTypes();
    }
  }, [props.program]);
  const value = availableOptions.find(
    (option) =>
      option.value && props.value && option.value === props.value.toLowerCase()
  );
  return (
    <CustomSelect
      placeholder={<div>{t(loading ? "Fetching..." : "Select report type")}</div>}
      options={availableOptions}
      onChange={props.onChange}
      value={value || null}
      disabled={loading}
    />
  );
};

export default ProgramReportTypeSelect;
